// import { CreateCustomer } from '@components/templates/customers/customers/create.customer/create-customer';
import { CreateExpenseCategory } from '@components/templates/expense/category/create-expense-category.modal';
import { CreateExpense } from '@components/templates/expense/create-expense.modal';
import { OrderInvoice } from '@components/templates/orders/order.invoice/order-invoice';
import { MakePayment } from '@components/templates/payment/make-payment';
// import { CreateBrand } from '@components/templates/products/brand/create.brand/create-brand';
import { EditBrand } from '@components/templates/products/brand/edit.brand/edit-brand';
// import { CreateGeneric } from '@components/templates/products/generic/create-generic';
import { ProductInfoEdit } from '@components/templates/products/products/update.product/edit-product-info-modal';
// import { CreateStrength } from '@components/templates/products/strength/create-strength';
// import { CreateType } from '@components/templates/products/type/create-type';
// import { CreateUnit } from '@components/templates/products/unit/create-unit';
import { EditUnit } from '@components/templates/products/unit/edit.unit/edit-unit';
import { PurchaseInvoice } from '@components/templates/purchase/purchase.invoice/purchase-invoice';
import { SaveDraft } from '@components/templates/sales/create.sale/draft/save-draft';
import { ShowDraft } from '@components/templates/sales/create.sale/draft/show-draft';

import MakePurchasePayment from '@/components/templates/purchase/purchase-payment/purchase-payment';
import { SalesReturnModal } from '@/components/templates/sales-return';
import { CreateUser } from '@/components/templates/users/create.user/create-user';
import { MODAL_ROUTE } from '@/constants';
import { useAppSelector } from '@/features';
import { CreateCustomerModal } from '@/modules/customers';
import { UpdateCustomerModal } from '@/modules/customers/update-customer';
import {
    CreateBrand,
    CreateGeneric,
    CreateStrength,
    CreateType,
    CreateUnit,
} from '@/modules/products';

import { UpdateTypeModal } from '../../templates/products/type/update-type.modal';
import { CreateSupplierModal } from '../../templates/suppliers/create.supplier/create-supplier';
import { EditSupplierModal } from '../../templates/suppliers/edit-supplier';

export const useModalSwitch = () => {
    const modalContent = useAppSelector(
        (state) => state.eventSlice.modalContent,
    );

    switch (modalContent) {
        case MODAL_ROUTE.CREATE_PRODUCT_BRAND:
            return <CreateBrand />;

        case MODAL_ROUTE.CREATE_PRODUCT_UNIT:
            return <CreateUnit />;

        case MODAL_ROUTE.CREATE_PRODUCT_GENERIC:
            return <CreateGeneric />;

        case MODAL_ROUTE.CREATE_PRODUCT_STRENGTH:
            return <CreateStrength />;

        case MODAL_ROUTE.CREATE_PRODUCT_TYPE:
            return <CreateType />;

        case MODAL_ROUTE.UPDATE_PRODUCT_TYPE:
            return <UpdateTypeModal />;

        case MODAL_ROUTE.CREATE_USER:
            return <CreateUser />;

        case MODAL_ROUTE.CREATE_SUPPLIER:
            return <CreateSupplierModal />;

        case MODAL_ROUTE.UPDATE_SUPPLIER:
            return <EditSupplierModal />;

        case MODAL_ROUTE.UPDATE_CUSTOMER:
            return <UpdateCustomerModal />;

        case MODAL_ROUTE.CREATE_CUSTOMER:
            return <CreateCustomerModal />;

        case MODAL_ROUTE.CART_SAVE_AS_DRAFT:
            return <SaveDraft />;

        case MODAL_ROUTE.CART_DRAFT_LIST:
            return <ShowDraft />;

        case MODAL_ROUTE.MAKE_PAYMENT:
            return <MakePayment />;

        case MODAL_ROUTE.UPDATE_PRODUCT_BRAND:
            return <EditBrand />;

        case MODAL_ROUTE.UPDATE_PRODUCT_UNIT:
            return <EditUnit />;

        case MODAL_ROUTE.INVOICE_PURCHASE:
            return <PurchaseInvoice />;

        case MODAL_ROUTE.INVOICE_ORDER:
            return <OrderInvoice />;

        case MODAL_ROUTE.UPDATE_PRODUCT_INFO:
            return <ProductInfoEdit />;

        case MODAL_ROUTE.CART_SALES_RETURN:
            return <SalesReturnModal />;

        case MODAL_ROUTE.CREATE_EXPENSE:
            return <CreateExpense />;

        case MODAL_ROUTE.CREATE_EXPENSE_CATEGORY:
            return <CreateExpenseCategory />;

        case MODAL_ROUTE.PURCHASE_PAYMENT:
            return <MakePurchasePayment />;
    }
};
